import type { TFunction } from 'i18next';

import type { FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import { SocialPostStatus, type SocialPost } from '@nucleus-commerce/api-client/admin';

/** Filters of the posts table, in the order the filter menu lists them. */
export function postFilters(t: TFunction): Array<FilterDef<SocialPost>> {
  return [
    {
      key: 'status',
      label: t('posts.filters.status'),
      type: 'enum',
      pinned: true,
      options: Object.values(SocialPostStatus).map((value) => ({
        value,
        label: t(`postStatus.${value}`),
      })),
    },
  ];
}
